import { Typography, Box, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import AnimatedNumber from "react-animated-numbers";
import CtaButton from "./CtaButton";
import SpeedingTooltip from "./SpeedingTooltip";

const useStyles = makeStyles((theme) => ({
  title: {
    marginLeft: theme.spacing(3),
    [theme.breakpoints.up("md")]: {
      marginLeft: theme.spacing(7),
    },
  },
  resultWrapper: {
    [theme.breakpoints.between("sm", "md")]: {
      display: "flex",
    },
  },
  container: {
    maxWidth: "65%",
    width: "auto",
    margin: "auto",
    marginTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    border: "1px solid " + theme.palette.button.main,
    borderRadius: theme.borderRadius.default,
    backgroundColor: theme.palette.background.white,
    [theme.breakpoints.between("sm", "md")]: {
      maxWidth: "82.5%",
      marginLeft: theme.spacing(3),
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1.5),
    },
  },
  label: {
    fontWeight: theme.typography.fontWeightMedium,
    textAlign: "right",
    fontSize: "1.25em",
    paddingLeft: theme.spacing(0.5),
  },
  result: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: "1.25em",
    display: "flex",
    flexDirection: "row",
    "& > span": {
      marginLeft: "2px",
    },
  },
  note: {
    marginTop: theme.spacing(0.5),
    margin: "auto",
    width: "65%",
    fontSize: theme.typography.pxToRem(8),
    [theme.breakpoints.up("md")]: {
      marginTop: theme.spacing(1.5),
    },
    [theme.breakpoints.between("sm", "md")]: {
      width: "82.5%",
      marginLeft: theme.spacing(3),
    },
  },
  ctaArea: {
    [theme.breakpoints.between("sm", "md")]: {
      padding: theme.spacing(0, 3),
    },
  },
  banner: {
    marginTop: theme.spacing(3),
    width: "90%",
    textAlign: "center",
    margin: "auto",
    fontSize: "0.8rem",
    fontWeight: theme.typography.fontWeightBold,
    [theme.breakpoints.up("md")]: {
      marginTop: theme.spacing(2),
      fontSize: "1rem",
    },
    [theme.breakpoints.between("sm", "md")]: {
      fontSize: "1rem",
      width: "100%",
      marginTop: theme.spacing(3.5),
    },
  },
}));

const AnimatedValue = ({ value }) => (
  <AnimatedNumber height={"1rem"} animateToNumber={value} />
);

const Result = ({ result }) => {
  const classes = useStyles();
  const { fineAmount, licencePoints, drivingBanPeriodInMonths } = result;

  return (
    <Box>
      <Typography variant="h2" className={classes.title}>
        Ergebnis
      </Typography>

      <div className={classes.resultWrapper}>
        <div>
          <Box mb={2} className={classes.container}>
            <Grid container spacing={3}>
              <Grid className={classes.label} item xs={6}>
                Bußgeld:
              </Grid>
              <Grid className={classes.result} item xs={6}>
                {formatFineAmount(fineAmount)}*
              </Grid>
            </Grid>
            <Grid alignItems="center" container spacing={3}>
              <Grid className={classes.label} item xs={6}>
                Punkte:
              </Grid>
              <Grid className={classes.result} item xs={1}>
                {formatLicencePoints(licencePoints)}
              </Grid>
              <SpeedingTooltip />
            </Grid>
            <Grid container spacing={3}>
              <Grid className={classes.label} item xs={6}>
                Fahrverbot:
              </Grid>
              <Grid className={classes.result} item xs={6}>
                {formatDrivingBanPeriod(drivingBanPeriodInMonths)}
              </Grid>
            </Grid>
          </Box>
          <p className={classes.note}>
            *Dieser Wert kann in Abhängigkeit von deinem Punktestand in
            Flensburg oder vorsätzlichen Handelns abweichen.
          </p>
        </div>

        <div className={classes.ctaArea}>
          <p className={classes.banner}>
            Bußgeldbescheide sind häufig fehlerhaft!
          </p>

          <CtaButton />
        </div>
      </div>
    </Box>
  );
};

const formatFineAmount = (fineAmount = 0) => {
  const localeString = fineAmount.toLocaleString("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  const splitAnimations = localeString
    .replace(/\s/g, "")
    .split("")
    .map((val) => {
      return isNaN(val) ? (
        formatString(val)
      ) : (
        <AnimatedValue value={parseInt(val)} />
      );
    });

  return splitAnimations;
};

const formatLicencePoints = (points = 0) => {
  return <AnimatedValue value={points} />;
};

const formatString = (string) => <span key={string}>{string}</span>;

const formatDrivingBanPeriod = (drivingBanPeriodInMonths = 0) => {
  const monthString = drivingBanPeriodInMonths === 1 ? "Monat" : "Monate";

  if (Number.POSITIVE_INFINITY === drivingBanPeriodInMonths) {
    return "Verlust des Führerscheins";
  }

  return (
    <>
      <AnimatedValue value={drivingBanPeriodInMonths} />
      {formatString(monthString)}
    </>
  );
};

export default Result;
